import { createFileRoute, redirect } from '@tanstack/react-router';

// CPH-003: same retirement as /reconciliation. The staged-items workspace
// surfaces under /close/sort/{bank,processor} once CPH-006 lands; until
// then the close hub is the parking spot for bookmarks.
export const Route = createFileRoute('/admin/finance/staged')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/close' });
  },
});
